import React, { useEffect } from 'react'
import { useSelector } from 'react-redux'
import { BonusState } from '../models/bonus.interface'
import { useBonus } from './useBonus'
import { useConnectWallet } from './useConnectWallet'
import { isCorrectNetwork } from '../utils'

const useBonusManager = () => {
  const { totalAvailable, totalBonus, transection, hasBonus, dealDate } = useSelector<
    BonusState,
    BonusState
  >((state) => state.bonus)

  const { contributeBalance, withDrawAvailableBalance } = useBonus()

  const { account, chainId, library } = useConnectWallet()

  useEffect(() => {
    if (account && library) {
      if (!isCorrectNetwork(chainId)) return null
      contributeBalance()
    }
  }, [account, library])


  const withDraw = () => {
    withDrawAvailableBalance()
  }

  return {
    totalAvailable,
    totalBonus,
    transection,
    hasBonus,
    dealDate,
    withDraw,
  }
}

export default useBonusManager
